export const CONFIG_PATH = 'bonzai/config.json';

export const DEFAULT_CONFIG = {
  customChecks: {
    requirements: ''
  },
  autoBurn: {
    enabled: false
  },
  eslint: {
    enabled: true,
    rules: ['no-unused-vars']
  },
  typescript: {
    enabled: true
  },
  lineLimit: {
    enabled: true,
    limit: 300,
    prompt: 'Split any file with over {{ linelimit }} lines into smaller files.'
  },
  folderLimit: {
    enabled: true,
    limit: 15,
    prompt: 'Split any folder with over {{ folderlimit }} items into smaller, compartmentalized folders.'
  },
  testCheck: {
    enabled: false,
    patterns: {
      '.vue': '.test.js',
      '.jsx': '.test.jsx',
      '.tsx': '.test.tsx'
    },
    prompt: 'Create test files for components that are missing them.'
  }
};
